import React, { useState, useEffect } from 'react';
import userIcon from '../../../../assets/images/user-icon.png'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CreatableSelect from "react-select/creatable";
import Axios from "axios";
import { Link, useLocation } from 'react-router-dom';
import { userDetailHeader } from '../../../../store/actions/userDataActions';
import { useTranslation } from 'react-i18next';

export default function ProfileDropdown() {
    const [userId, setuserId] = useState('');
    const [userName, setuserName] = useState('');
    const [userEmail, setuserEmail] = useState('');
    const dispatch = useDispatch()
    const location = useLocation();
    const languageOptions = [

        { value: 'en', label: 'English' },
        { value: 'pt', label: 'Portuguese' },
        { value: 'sq', label: 'Albanian' }
    ];



    const { userData, userFlag } = useSelector((state) => state.userDataHeader)
    console.log( "userData------", userData);


    const { t, i18n } = useTranslation();
    // const userDefaultLanguage = userData[0]?.default_language || "en";
    // const storedLanguage = localStorage.getItem("i18nextLng") || userDefaultLanguage;

    // const [selectedLanguage, setSelectedLanguage] = useState(() =>
    //     localStorage.getItem('i18nextLng') || userData[0]?.default_language || 'en'
    // );

    const defaultLang = localStorage.getItem('i18nextLng');

    // console.log("default lang", defaultLang)
    const [selectedLanguage, setSelectedLanguage] = useState(defaultLang ? defaultLang : "en");

    const [initialized, setInitialized] = useState(false);
    //console.log("initial lang--",initialLanguage)

    useEffect(()=>{
        setSelectedLanguage(defaultLang)
    }, [defaultLang])


    const handleLanguageChange = (selectedOption) => {
        const newLanguage = selectedOption.value;
        setSelectedLanguage(newLanguage);
        i18n.changeLanguage(newLanguage);
        localStorage.setItem('i18nextLng', newLanguage);
        console.log("Selected Language:", newLanguage);

    };

    // useEffect(() => {
    //     const applyLanguage = userData[0]?.default_language;

    //         console.log("Selected Language11:", selectedLanguage);
    //         //alert(selectedLanguage);
    //         const langval = selectedLanguage ? selectedLanguage : applyLanguage
    //         //alert(langval);
    //         localStorage.setItem('i18nextLng', langval);
    //         console.log("langvale----",langval)

    // }, [selectedLanguage]);

    // useEffect(() => {
    //     if (userData.length > 0) {
    //         const defaultLanguage = userData[0]?.default_language || 'en';

    //         // Force reset language on login
    //         if (i18n.language !== defaultLanguage) {
    //             i18n.changeLanguage(defaultLanguage);
    //             localStorage.setItem('i18nextLng', defaultLanguage);
    //             setSelectedLanguage(defaultLanguage);
    //         }
    //     }
    // }, [userData,i18n]);

    useEffect(() => {
        if (userData.length > 0 && !initialized) {
            const defaultLanguage = userData[0]?.default_language || 'en';

            // Set the default language only once on login
            if (!localStorage.getItem('i18nextLng')) {
                i18n.changeLanguage(defaultLanguage);
                localStorage.setItem('i18nextLng', defaultLanguage);
                setSelectedLanguage(defaultLanguage);
                console.log('Default Language Set:', defaultLanguage);
            }
            setInitialized(true); // Prevent re-initialization
        }
    }, [userData, i18n, initialized]);

    // Handle language changes within the session
    useEffect(() => {
        const applyLanguage = userData[0]?.default_language || 'en';
        const langval = selectedLanguage || applyLanguage;

        if (i18n.language !== langval) {
            i18n.changeLanguage(langval);
            localStorage.setItem('i18nextLng', langval);
            console.log('Applied Language:', langval);
        }
    }, [selectedLanguage, userData, i18n]);



    useEffect(() => {
        if (userFlag == false) {
            checkToken(localStorage.getItem('token_id'));
            dispatch(userDetailHeader());
        } else {

            userData.forEach(element => {
                let mp = JSON.parse(element.module_permissions)
                window.modulePermissions.M1.view = (mp?.M1?.view == 1) ? 1 : window.modulePermissions.M1.view;
                window.modulePermissions.M1.add = (mp?.M1?.add == 1) ? 1 : window.modulePermissions.M1.add;
                window.modulePermissions.M1.edit = (mp?.M1?.edit == 1) ? 1 : window.modulePermissions.M1.edit;
                window.modulePermissions.M1.del = (mp?.M1?.del == 1) ? 1 : window.modulePermissions.M1.del;
                window.modulePermissions.M2.view = (mp?.M2?.view == 1) ? 1 : window.modulePermissions.M2.view;
                window.modulePermissions.M3.view = (mp?.M3?.view == 1) ? 1 : window.modulePermissions.M3.view;
                window.modulePermissions.M3.add = (mp?.M3?.add == 1) ? 1 : window.modulePermissions.M3.add;
                window.modulePermissions.M3.edit = (mp?.M3?.edit == 1) ? 1 : window.modulePermissions.M3.edit;
                window.modulePermissions.M3.del = (mp?.M3?.del == 1) ? 1 : window.modulePermissions.M3.del;
                window.modulePermissions.M4.view = (mp?.M4?.view == 1) ? 1 : window.modulePermissions.M4.view;
                window.modulePermissions.M4.add = (mp?.M4?.add == 1) ? 1 : window.modulePermissions.M4.add;
                window.modulePermissions.M4.edit = (mp?.M4?.edit == 1) ? 1 : window.modulePermissions.M4.edit;
                window.modulePermissions.M4.del = (mp?.M4?.del == 1) ? 1 : window.modulePermissions.M4.del;
                window.modulePermissions.M5.view = (mp?.M5?.view == 1) ? 1 : window.modulePermissions.M5.view;
                window.modulePermissions.M5.add = (mp?.M5?.add == 1) ? 1 : window.modulePermissions.M5.add;
                window.modulePermissions.M5.edit = (mp?.M5?.edit == 1) ? 1 : window.modulePermissions.M5.edit;
                window.modulePermissions.M5.del = (mp?.M5?.del == 1) ? 1 : window.modulePermissions.M5.del;
                window.modulePermissions.M6.del = (mp?.M6?.del == 1) ? 1 : window.modulePermissions.M6.del;
                window.modulePermissions.M8.view = (mp?.M8?.view == 1) ? 1 : window.modulePermissions.M8.view;
                window.modulePermissions.M8.add = (mp?.M8?.add == 1) ? 1 : window.modulePermissions.M8.add;
                window.modulePermissions.M8.edit = (mp?.M8?.edit == 1) ? 1 : window.modulePermissions.M8.edit;
                window.modulePermissions.M8.del = (mp?.M8?.del == 1) ? 1 : window.modulePermissions.M8.del;
                window.modulePermissions.M9.view = (mp?.M9?.view == 1) ? 1 : window.modulePermissions.M9.view;
                window.modulePermissions.M9.add = (mp?.M9?.add == 1) ? 1 : window.modulePermissions.M9.add;
                window.modulePermissions.M9.edit = (mp?.M9?.edit == 1) ? 1 : window.modulePermissions.M9.edit;
                window.modulePermissions.M9.del = (mp?.M9?.del == 1) ? 1 : window.modulePermissions.M9.del;
                window.modulePermissions.M10.view = (mp?.M10?.view == 1) ? 1 : window.modulePermissions.M10.view;
                window.modulePermissions.M10.add = (mp?.M10?.add == 1) ? 1 : window.modulePermissions.M10.add;
                window.modulePermissions.M10.edit = (mp?.M10?.edit == 1) ? 1 : window.modulePermissions.M10.edit;
                window.modulePermissions.M10.del = (mp?.M10?.del == 1) ? 1 : window.modulePermissions.M10.del;
                for (let i = 11; i <= 23; i++) {
                    const key = `M${i}`;
                    if (mp?.[key]) {
                        ['view', 'add', 'edit', 'del'].forEach(perm => {
                            window.modulePermissions[key][perm] = (mp[key][perm] == 1) ? 1 : window.modulePermissions[key][perm];
                        });
                    }
                }

            });

            // console.log(window.modulePermissions)
        }
    }, [userFlag])


   
   
  
    

    function logout() {
        Axios.get(process.env.REACT_APP_NODE_API_URL + "/users/logout", {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token_id')}`
            }
        }).then((response) => {
            if (response.status == 200) {
                localStorage.setItem('token_id', '');
                // alert("logout successfully!");
                localStorage.removeItem('i18nextLng');
                toast.success("logout successfully!");
                window.location.replace('/');;
            } else {
                alert("Try Again, Error");
            }
        });
    }

    const checkToken = async (token_id) => {
        // fetch(process.env.REACT_APP_NODE_API_URL + `/auth/getTokenData?token_id=` + token_id)
        //     .then(res => res.json())
        //     .then(
        //         (result) => {

        //             console.log(result);
        //             setuserId(result.id);
        //             setuserName(result.name);
        //             setuserEmail(result.email);
        //         },
        //         (error) => {
        //             console.log('error', error)
        //             alert("1 token not verified, or expired, Login Again");
        //             // window.location = '/';
        //         }
        //     )

    }
    return (
        <div className="dropdown profile-dropdown d-flex">

            <div className="cstom-select" style={{ marginRight: '20px' }}>
                {/* <label htmlFor="">Region</label> */}
                <CreatableSelect
                    //defaultValue={} // Set default to English
                    options={languageOptions}
                    value={languageOptions.find(
                        (option) => option.value === selectedLanguage
                    )}
                    //key={selectedLanguage.value}
                    onChange={handleLanguageChange}
                //placeholder="Select Language"
                />
            </div>

            <button type="button" id="dropdownprofile" data-bs-toggle="dropdown" aria-expanded="false">
                <div className="profile-info">
                    <div className="profileName">
                        {userData[0]?.name}
                    </div>
                    <div className="profle-desi">
                        {userData[0]?.email}
                    </div>
                </div>
                {userData[0]?.profile_image ? (
                    <img
                        src={`${process.env.REACT_APP_NODE_API_URL?.replace('/api', '')}${userData[0].profile_image}`}
                        alt=""
                        width={35}
                        height={35}
                        className="ms-2"
                        style={{ borderRadius: "50%", objectFit: "cover" }}
                    />
                ) : (
                    <img src={userIcon} alt="" width={35} height={35} className="ms-2" />
                )}
                <svg width={10} height={8} viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M9.8002 1.5998C9.8002 1.1598 9.4402 0.799805 9.0002 0.799805H1.0002C0.560195 0.799805 0.200195 1.1598 0.200195 1.5998C0.200195 1.7918 0.280195 1.9678 0.392195 2.1038L0.384195 2.1118L4.38419 6.9118L4.3922 6.9038C4.5442 7.0798 4.7522 7.1998 5.0002 7.1998C5.2482 7.1998 5.4562 7.0798 5.6082 6.9038L5.6162 6.9118L9.6162 2.1118L9.6082 2.1038C9.7202 1.9678 9.8002 1.7918 9.8002 1.5998Z" fill="#E60000" />
                </svg>

            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownprofile">
                <li><Link className="dropdown-item" to="/admin/settings/profile">{t('survey.editP')}</Link></li>
                {/* <li><a className="dropdown-item" href="">Settings</a> </li> */}
                {/* <div className="dropdown-divider"></div> */}
                <li><a className="dropdown-item" onClick={logout}>{t('survey.logout')}
                </a> </li>
            </ul>

        </div>
    )
}
